import YogaNavBar from "./YogaNavBar";
import ContactMe from "./YogaContactMe";
import InstagramEmbed from "./YogaInstagramEmbed";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import MyOfferings from "./YogaOfferings";


export default function YogaLandingPage() {
    const imageUrl = 'https://www.sinaklughardt.com/static/media/arizona_yoga.ee0824a4294c9a19e376.jpeg';

    return (
        <>
        <Helmet>
            <title>Sina In Flux Yoga</title>
            <meta property="og:title" content="Sina In Flux Yoga"/>
            <meta property="og:description" content="Yoga that aligns with nature’s rhythms. Join outdoor yoga classes in San Diego to feel at home in your body and shine your light." />
            <meta property="og:image" content={imageUrl} />
        </Helmet>
        <YogaNavBar />
        <div className="relative">
            <img
                src={require("./images/arizona_yoga.jpeg")}
                alt="Sina Klughardt Yoga"
                className="w-full h-[400px] md:h-full object-cover"
            />

             <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-2/3 w-full text-center text-white text-2xl md:text-4xl">
                Sina In Flux Yoga
            </div>
        </div>
        <div className="md:flex md:m-10">
  <div className="md:w-1/2 m-5 flex justify-center md:justify-center">
    <img
      className="rounded h-60 w-60 md:h-80 md:w-80 mt-5 md:mt-0"
      src={require("./images/sina-headshot.jpg")}
      alt="Sina Headshot"
    />
  </div>
    <div className="md:w-1/2 m-5">
        <h1 className="text-4xl">About Me</h1>
        <p className="mt-5 md:mr-10 md:text-lg">
            I am a nature lover, adventure seeker, and passionate yogi who finds deep inspiration in the natural world.
            My journey has taken me through breathtaking national parks, where I connect with the ever-changing landscapes and rhythms of the earth.
        </p>
        <p className="my-3 md:text-lg">
        My path has taken me across continents — from my roots in Germany to building a new home here in San Diego. Along the way, I’ve grown, explored, and learned to listen more deeply to myself, others, and the world around me. Nature keeps teaching me, and I’m here to share that connection through movement, breath, and community.
        </p>
    </div>
</div>
<MyOfferings />

<div className="grid place-items-center">
  <ContactMe />
  <InstagramEmbed />
</div>
        </>
    );
}
